export default __webpack_public_path__ + "static/media/akc-simplified.1059047b.svg";